export default "__VITE_ASSET__84cb3a59__"